import {
  AppPageHeader,
  ColumnsType,
  DeleteIcon,
  EditIcon,
  InfiniteTable,
} from '@/components/_common';
import { useDebounce, useDisclosure } from '@/hooks';
import { usePersistSearchParams } from '@/utils/queryParams';
import convertParams from '@/utils/queryParams/convertParams';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Divider, Modal, Space, Tag } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  SaleTag,
  SaleTagsQueryFilter,
} from '@/core/domain/sales/SaleTags/SaleTags.types';
import {
  useDeleteSaleTag,
  useSalesTags,
} from '@/core/domain/sales/SaleTags/SaleTags.hooks';
import TagsDirectSaleModal from '../TagsDirectSaleModal';

export default function TagsDirectSaleList() {
  const intl = useIntl();

  const [queryParams, setQueryParams] = useState<SaleTagsQueryFilter>({
    order: 'ASC',
    ...convertParams<SaleTagsQueryFilter>({
      name: 'string',
    }),
  });
  const [tagSelected, setTagSelected] = useState<SaleTag>();
  const [modalEditOpened, modalEditActions] = useDisclosure();

  const queryDebounce = useDebounce(queryParams, 500);
  usePersistSearchParams(queryDebounce);

  const { data, isFetching, fetchNextPage, hasNextPage } =
    useSalesTags(queryDebounce);

  const saleTags = flatInfiniteData(data);

  const deleteSaleTag = useDeleteSaleTag();

  const handleRemoveClick = (id: number) => {
    Modal.confirm({
      title: 'Atenção!',
      content: 'Deseja realmente excluir essa etiqueta?',
      onOk: async () => await deleteSaleTag.mutateAsync(id),

      okType: 'danger',
    });
  };

  const columns: ColumnsType<SaleTag> = [
    {
      dataIndex: 'name',
      title: 'Descrição',
      render: (_, record) => (
        <Tag color={record.color}>{record.name.toUpperCase()}</Tag>
      ),
    },
    {
      dataIndex: 'actions',
      title: intl.formatMessage({ id: 'customers.list.header.actions' }),
      render: (_, row) => (
        <Space>
          <EditIcon
            iconProps={{
              onClick: () => {
                setTagSelected(row);
                modalEditActions.open();
              },
            }}
          />

          <Divider type="vertical" />

          <DeleteIcon onClick={() => handleRemoveClick(row.id)} />
        </Space>
      ),
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <>
      <AppPageHeader
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, search: value }))
        }
      />

      <InfiniteTable<SaleTag>
        columns={columns}
        dataSource={saleTags}
        loading={isFetching}
        rowKey={(row) => row.id}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
      />

      <TagsDirectSaleModal
        tagDetail={tagSelected}
        open={modalEditOpened}
        onCancel={() => {
          modalEditActions.close();
          setTagSelected(undefined);
        }}
      />
    </>
  );
}
